import { signedInIdentity, type Account } from "../account";

const LINK_CLASS =
  "font-bold text-evergreen underline underline-offset-4 hover:text-plum";

/** Who the form is signed in as, and the way out for someone it isn't. */
export default function SignedInAs({
  account,
  onSignOut,
  className,
}: {
  account: Account | null;
  onSignOut: () => void;
  className?: string;
}) {
  const identity = account ? signedInIdentity(account) : "";
  return (
    <div className={`text-base text-oat-700 ${className ?? ""}`}>
      {identity !== "" && (
        <p>
          Signed in as <span className="ph-no-capture">{identity}</span>
        </p>
      )}
      <p>
        Not you?{" "}
        <button type="button" className={LINK_CLASS} onClick={onSignOut}>
          Sign out
        </button>
      </p>
    </div>
  );
}
